export default __webpack_public_path__ + "AUt_bulkUser.html";